export const detailsRules = (options) => (step = {}, data) => ({
  userKeepSignIn: {
    required: !options.config.hiddenQuestions['user-keep-me-sign-in'],
    typeof: 'boolean',
  },
});

export const createMotorhomeRules = (data, config) => {
  const validationHelpers = {};

  validationHelpers.config = config;

  return {
    detailsRules: detailsRules(validationHelpers),
  };
};
